import React, { useState } from 'react'
import AccordionChildContent from './accordion-child-content'
import swal from 'sweetalert'

const AccordionChild = ({ title = '', content = [] }) => {
  const [isShow, setShow] = useState(false)
  const [isResponse, setResponse] = useState(false)
  const [isSatisfied, setSatisfied] = useState(false)
  const [isOpenform, setOpenform] = useState(false)
  const [phone, setPhone] = useState('')
  const [message, setmessage] = useState('')
  const [disable, setDisable] = useState(true)
  const [isForm, setForm] = useState(false)

  const handleClickAccordionParent = e => {
    e.preventDefault()
    setShow(prevState => {
      return !prevState
    })
  }

  const isEnabled = phone.length > 0 && message.length > 0

  const checkField = () => {
    const pattern_phone = /^\d+$/

    if (pattern_phone.test(phone) == false) {
      return swal('Warning', 'Phone number is invalid', 'warning')
    }

    if (message === '') {
      return swal('Warning', 'Fill the message area', 'warning')
    }

    setSatisfied(!isSatisfied)
    setOpenform(!isOpenform)
  }

  return (
    <div className="content-accordion">
      <div className="content-accordion-top">
        <a href="/" onClick={handleClickAccordionParent} className="title">
          <span className="title-accordion">{title}</span>
          <div className="arrow">
            <i className={`icon-arrow ${isShow ? 'up' : 'down'}`}></i>
          </div>
        </a>
      </div>
      <div className={`content-parent ${isShow ? 'active' : ''}`}>
        {content.length > 0 ? (
          <div className="content-accordion-bottom">
            <div className="content-child">
              <ol className={content.length > 1 ? 'list-number' : 'list-none'}>
                {content.map((item, key) => (
                  <AccordionChildContent
                    {...item}
                    key={key}
                  ></AccordionChildContent>
                ))}
              </ol>
            </div>
          </div>
        ) : (
            false
          )}
        {
          !isResponse &&
          <div className="fvb-wrap">
            <p>Apakah penjelasan ini sudah membantu anda?</p>
            <div className="fvb-flx">
              <button
                className="fvb-st"
                onClick={() => { setSatisfied(!isSatisfied); setResponse(!isResponse); }}
              >
                Sudah, terima kasih
              </button>
              <button
                className="fvb-st"
                onClick={() => { setOpenform(!isOpenform); setResponse(!isResponse); }}
              >
                Belum, saya masih butuh bantuan
              </button>
            </div>
          </div>
        }
        {
          isSatisfied &&
          <div className="thanks">
            <span>Terima kasih atas feedback anda</span>
          </div>
        }
        {
          isOpenform &&
          <div className="dl-faq">
            <div className="dtl-ttl-wrp">
              <span>
                Kami mohon maaf atas pengalaman yang kurang menyenangkan yang anda alami.
                </span>
            </div>
            <div className="frm-fddbck">
              <input
                type="tel"
                pattern="^-?[0-9]\d*\.?\d*$"
                name="phone"
                placeholder="Masukan nomor telepon anda.."
                onChange={e => {
                  setPhone(e.target.value)
                }}
              />
              <textarea
                rows="10"
                cols="50"
                name="pesan"
                placeholder="Ceritakan detail masalah yang anda alami disini.."
                onChange={e => {
                  setmessage(e.target.value)
                }}
              >
              </textarea>
            </div>
            <div className="btns-wrp">
              <button
                disabled={!isEnabled}
                className="snd-btn"
                onClick={checkField}
              >
                Kirim Detail Bantuan
                </button>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default AccordionChild
